var map = {
	"./abnormal_icon_breathe_h.png": "02c8",
	"./abnormal_icon_heart_h.png": "3d82",
	"./ai_icon_news_d@2x.png": "406f",
	"./ai_image_change_triangle_d@2x.png": "4fb5",
	"./backIconLeft.png": "b20a",
	"./backIconLeft2.png": "11a7",
	"./backIconRight.png": "004a",
	"./backIconRight2.png": "487a",
	"./banCir.png": "4357",
	"./btn_back_ove.png": "f6c04",
	"./btn_reset_dis.png": "2aa7",
	"./btn_reset_hover.png": "0008",
	"./btn_reset_nor.png": "67d0",
	"./check-circle-fill.png": "5f11",
	"./check-circle-fill2.png": "e45d",
	"./check.png": "f0c8",
	"./comment1.png": "7e96",
	"./comment2.png": "d8d3",
	"./comment3.png": "2ff4",
	"./comment4.png": "a2c2",
	"./energy.png": "3491",
	"./flipLeft.png": "8d5c",
	"./flipRight.png": "c880",
	"./great.png": "28bc",
	"./greenTriangle.png": "dcc9",
	"./gzImg/icon_portrait_report_image_1.png": "052e",
	"./gzImg/icon_portrait_report_image_2.png": "cbf5",
	"./gzImg/icon_portrait_report_image_3.png": "3fba",
	"./gzImg/icon_portrait_report_image_4.png": "6ad4",
	"./gzImg/icon_portrait_report_image_5.png": "c293",
	"./gzImg/icon_portrait_report_image_6.png": "eb4d",
	"./gzImg/icon_portrait_report_image_7.png": "097f",
	"./gzImg/icon_portrait_report_image_8.png": "7c17",
	"./gzImg/icon_portrait_report_image_9.png": "7561",
	"./gzImg/rep_green1.png": "9088",
	"./gzImg/rep_green2.png": "44d2",
	"./gzImg/rep_green3.png": "3deb",
	"./gzImg/rep_green4.png": "5b25",
	"./gzImg/rep_green5.png": "5653",
	"./gzImg/rep_green6.png": "7e92",
	"./gzImg/rep_red1.png": "3ac1",
	"./home_icon_avatar_h@2x.png": "7a17",
	"./home_icon_days_d.png": "1ffe",
	"./home_icon_quantity_d.png": "9158",
	"./home_pic_triangle_d.png": "af54",
	"./iconBuilding.png": "1151",
	"./iconFloor.png": "3971",
	"./iconOrangeAlarm.png": "8851",
	"./iconRoom.png": "f3b5",
	"./icon_AHI.png": "5b8b",
	"./icon_GoDown.png": "9b1f",
	"./icon_GoUp.png": "f526",
	"./icon_SleepLeave.png": "cbca",
	"./icon_SleepLeaveTime_36.png": "0542",
	"./icon_SleepLeave_36.png": "f299",
	"./icon_SleepProportion_24.png": "2bc1",
	"./icon_SleepTime_36.png": "f6af",
	"./icon_SleepTurn_36.png": "08c2",
	"./icon_activity.png": "8ab4",
	"./icon_admin_nursing_deploy_add_1.png": "50c3",
	"./icon_admin_nursing_deploy_close_1.png": "0596",
	"./icon_admin_radar_word_deploy_phone_1.png": "4267",
	"./icon_ai_depth_icon_1.png": "b75c",
	"./icon_ai_play.png": "c11e",
	"./icon_ai_report_icon_1.png": "d3fd",
	"./icon_ai_report_icon_2.png": "b9fe",
	"./icon_ai_report_icon_close_1.png": "8415",
	"./icon_ai_search_icon_1.png": "7f0a",
	"./icon_ai_search_icon_2.png": "68ff",
	"./icon_ai_search_icon_3.png": "bd0a",
	"./icon_alert_warning.png": "1207",
	"./icon_breathEvent.png": "0db2",
	"./icon_breath_24.png": "56f3",
	"./icon_breath_dis.png": "6602",
	"./icon_clock.png": "c5ec",
	"./icon_clock2.png": "860e",
	"./icon_common_close_1.png": "2d90",
	"./icon_common_empty_icon_new.png": "c0dc",
	"./icon_common_select_date_icon_1.png": "be20",
	"./icon_common_select_date_icon_2.png": "dd15",
	"./icon_common_share_1.png": "7684",
	"./icon_common_special_arrow_0.png": "8d76",
	"./icon_common_special_arrow_1.png": "c0e5",
	"./icon_common_special_arrow_10.png": "3974",
	"./icon_common_special_arrow_11.png": "f792",
	"./icon_common_special_arrow_12.png": "f8ae",
	"./icon_common_special_arrow_15.png": "f9c1",
	"./icon_common_special_arrow_16.png": "5999",
	"./icon_common_special_arrow_2.png": "a71c",
	"./icon_common_special_arrow_3.png": "1aad",
	"./icon_common_special_arrow_4.png": "915c",
	"./icon_common_special_arrow_5.png": "6ef3",
	"./icon_common_special_arrow_6.png": "4863",
	"./icon_common_special_arrow_7.png": "1cd2",
	"./icon_common_special_arrow_8.png": "0ca8",
	"./icon_common_special_arrow_9.png": "db24",
	"./icon_common_special_triangle_1.png": "94e3",
	"./icon_dealTime.png": "5334",
	"./icon_dealing.png": "d93d",
	"./icon_dean_home_alert_bg_1.png": "7579",
	"./icon_dean_home_alert_bg_2.png": "8c2f",
	"./icon_dean_home_alert_bg_3.png": "2a58",
	"./icon_dean_home_alert_icon_1.png": "9db2",
	"./icon_dean_home_alert_icon_10.png": "16f9",
	"./icon_dean_home_alert_icon_11.png": "436f5",
	"./icon_dean_home_alert_icon_12.png": "9b86",
	"./icon_dean_home_alert_icon_13.png": "e3ba",
	"./icon_dean_home_alert_icon_14.png": "49c5",
	"./icon_dean_home_alert_icon_15.png": "c106",
	"./icon_dean_home_alert_icon_16.png": "94d8",
	"./icon_dean_home_alert_icon_17.png": "0f13",
	"./icon_dean_home_alert_icon_2.png": "2273",
	"./icon_dean_home_alert_icon_3.png": "a06c",
	"./icon_dean_home_alert_icon_4.png": "99b2",
	"./icon_dean_home_alert_icon_5.png": "602b",
	"./icon_dean_home_alert_icon_6.png": "a259",
	"./icon_dean_home_alert_icon_7.png": "c8a6",
	"./icon_dean_home_alert_icon_8.png": "7389",
	"./icon_dean_home_alert_icon_9.png": "6473",
	"./icon_dean_home_bg_card_1.png": "0631",
	"./icon_dean_home_bg_card_1_1.png": "91a8",
	"./icon_dean_home_bg_card_2.png": "dc68",
	"./icon_dean_home_bg_card_5.png": "e4d9",
	"./icon_dean_home_bg_card_6.png": "ea39",
	"./icon_dean_home_bg_card_icon_1.png": "1c5c",
	"./icon_dean_home_bg_card_icon_10.png": "5f82",
	"./icon_dean_home_bg_card_icon_11.png": "c9f3",
	"./icon_dean_home_bg_card_icon_12.png": "343e",
	"./icon_dean_home_bg_card_icon_13.png": "ea56",
	"./icon_dean_home_bg_card_icon_14.png": "e2d0",
	"./icon_dean_home_bg_card_icon_2.png": "324b",
	"./icon_dean_home_bg_card_icon_3.png": "e29f",
	"./icon_dean_home_bg_card_icon_4.png": "2bfbb",
	"./icon_dean_home_bg_card_icon_5.png": "9e44",
	"./icon_dean_home_bg_card_icon_6.png": "09b0",
	"./icon_dean_home_bg_card_icon_7.png": "9702",
	"./icon_dean_home_bg_card_icon_8.png": "d4bd",
	"./icon_dean_home_bg_card_icon_9.png": "a9cb",
	"./icon_dean_home_card_empty_icon_1.png": "08b3",
	"./icon_dean_home_card_empty_icon_2.png": "d0f5",
	"./icon_dean_home_card_empty_icon_3.png": "aac3",
	"./icon_dean_home_card_measure_1.png": "bdd3",
	"./icon_dean_home_card_measure_10.png": "83dc",
	"./icon_dean_home_card_measure_2.png": "4102",
	"./icon_dean_home_card_measure_3.png": "3748",
	"./icon_dean_home_card_measure_4.png": "2d75",
	"./icon_dean_home_card_measure_5.png": "6819",
	"./icon_dean_home_card_measure_6.png": "e237",
	"./icon_dean_home_card_measure_7.png": "290e",
	"./icon_dean_home_card_measure_8.png": "e910",
	"./icon_dean_home_card_measure_9.png": "dbcc",
	"./icon_dean_home_report_measure_1.png": "b27a",
	"./icon_dean_old_healthy_icon_1.png": "00e4",
	"./icon_dean_old_healthy_icon_2.png": "eec3",
	"./icon_dean_old_healthy_icon_3.png": "1f76",
	"./icon_dean_old_healthy_icon_4.png": "9ae2",
	"./icon_dean_old_healthy_icon_5.png": "df17",
	"./icon_dean_old_healthy_icon_6.png": "00f5",
	"./icon_deepSleep.png": "9120",
	"./icon_deepSleep_dis.png": "699b",
	"./icon_deepSleep_nor.png": "b9ab",
	"./icon_emotion.png": "73a6",
	"./icon_fallDown.png": "b31e",
	"./icon_health_data_back_icon.png": "fe4e",
	"./icon_health_data_search_input_icon_1.png": "58c3",
	"./icon_health_data_search_input_icon_2.png": "dbdc",
	"./icon_heartRate_24.png": "368e",
	"./icon_heartRate_24@2x.png": "b195",
	"./icon_heart_dis.png": "c498",
	"./icon_home_ai_arrow_30.png": "19ad",
	"./icon_home_ai_arrow_31.png": "70c2",
	"./icon_home_ai_icon_0.png": "a304",
	"./icon_home_ai_icon_1.png": "e934",
	"./icon_home_ai_icon_10.png": "2d8c",
	"./icon_home_ai_icon_11.png": "8145",
	"./icon_home_ai_icon_12.png": "e297",
	"./icon_home_ai_icon_13.png": "7e83",
	"./icon_home_ai_icon_15.png": "06de",
	"./icon_home_ai_icon_16.png": "49ac",
	"./icon_home_ai_icon_2.png": "eb27",
	"./icon_home_ai_icon_3.png": "3355",
	"./icon_home_ai_icon_3_1.png": "6c43",
	"./icon_home_ai_icon_3_2.png": "633c",
	"./icon_home_ai_icon_5.png": "a0d4",
	"./icon_home_ai_icon_6.png": "b565",
	"./icon_home_ai_icon_7.png": "0a4d",
	"./icon_home_ai_icon_8.png": "3dc3",
	"./icon_home_ai_icon_9.png": "4197",
	"./icon_home_first_card_export_icon.png": "27bf",
	"./icon_home_hei_san_jiao_1.png": "d8ab",
	"./icon_home_hei_san_jiao_2.png": "f451",
	"./icon_home_new_icon_bg_1.png": "ffaf",
	"./icon_home_new_icon_bg_2.png": "a733",
	"./icon_home_new_icon_chang_tiao_fang_ge.png": "d871",
	"./icon_home_new_icon_dou_hao_1.png": "c38f",
	"./icon_home_new_icon_dou_hao_2.png": "c481",
	"./icon_home_new_icon_empty_10.png": "9a2b",
	"./icon_home_new_icon_fanwei_1.png": "c1d1",
	"./icon_home_new_icon_fanwei_2.png": "d2fd",
	"./icon_home_new_icon_fanwei_3.png": "2cf9",
	"./icon_home_new_icon_jian_tou_lan.png": "3f5f",
	"./icon_home_new_icon_san_jiao_1.png": "eba9",
	"./icon_home_new_icon_san_jiao_2.png": "0cb5",
	"./icon_home_new_icon_san_jiao_3.png": "a0b2",
	"./icon_home_new_icon_san_jiao_5.png": "e3dc",
	"./icon_home_new_icon_yellow_warning.png": "2f86",
	"./icon_home_tip_error_1.png": "8725",
	"./icon_home_tip_success_1.png": "39b8",
	"./icon_keep.png": "7c68",
	"./icon_lightSleep_dis.png": "0cf2",
	"./icon_lightSleep_nor.png": "e94b",
	"./icon_notice.png": "98a0",
	"./icon_notice_d@2x.png": "d067",
	"./icon_noworking.png": "c041",
	"./icon_offline.png": "4471",
	"./icon_onlineTime.png": "756a",
	"./icon_portrait_arrow_1.png": "6601",
	"./icon_portrait_arrow_2.png": "d31f",
	"./icon_portrait_tip_alert_arrow_left.png": "52d0",
	"./icon_portrait_tip_alert_arrow_right.png": "5d30",
	"./icon_portrait_wranning_1.png": "0da9",
	"./icon_protect_home_phone_alarm_1.png": "9fc1",
	"./icon_protect_home_phone_alarm_2.png": "d4a6",
	"./icon_protect_home_phone_alarm_3.png": "bd91",
	"./icon_protect_home_phone_alarm_4.png": "9df5",
	"./icon_protect_home_phone_alarm_5.png": "458d",
	"./icon_protect_home_phone_alarm_6.png": "4cda",
	"./icon_protect_home_phone_alarm_7.png": "3992",
	"./icon_protect_home_phone_alarm_8.png": "9a0b",
	"./icon_protect_home_phone_alarm_9.png": "cbb8",
	"./icon_report_empty_logo_1.png": "cc93",
	"./icon_report_empty_logo_2.png": "13b9",
	"./icon_report_empty_logo_3.png": "5fa6",
	"./icon_report_empty_logo_4.png": "2bac",
	"./icon_responseTime.png": "54f2",
	"./icon_share.png": "074c",
	"./icon_sleepBreath.png": "7021",
	"./icon_sleepScore.png": "3930",
	"./icon_sos_btn_bell_1.png": "ed9c",
	"./icon_sos_btn_bell_2.png": "eec2",
	"./icon_sos_btn_bell_3.png": "9c291",
	"./icon_sos_btn_bell_4.png": "68dc",
	"./icon_sos_btn_bell_5.png": "27ae",
	"./icon_sos_btn_bell_6.png": "85d4",
	"./icon_sos_btn_bell_7.png": "d34a",
	"./icon_sos_btn_bell_8.png": "e394",
	"./icon_star.png": "0735",
	"./icon_starB.png": "9d5cb",
	"./icon_top_nav_logout_0.png": "a7c1",
	"./icon_top_nav_logout_1.png": "4e35",
	"./icon_top_nav_msg_0.png": "c673",
	"./icon_top_nav_msg_1.png": "54fa",
	"./icon_top_nav_selected_bg.png": "5659",
	"./icon_top_nav_selected_icon_00.png": "44eb",
	"./icon_top_nav_selected_icon_01.png": "eb20",
	"./icon_top_nav_selected_icon_10.png": "f716",
	"./icon_top_nav_selected_icon_11.png": "1fdb",
	"./icon_top_nav_selected_icon_20.png": "4f6f",
	"./icon_top_nav_selected_icon_21.png": "fd7f",
	"./icon_top_nav_selected_icon_30.png": "c151",
	"./icon_top_nav_selected_icon_31.png": "1371",
	"./icon_top_nav_time.png": "08b5",
	"./icon_trashCan_dis.png": "197e",
	"./icon_trashCan_nor.png": "19bf",
	"./icon_trashCan_ove (1).png": "c407",
	"./icon_trashCan_ove.png": "7410",
	"./icon_user.png": "44e1",
	"./icon_wake_dis.png": "cd81",
	"./icon_work_proposal_icon_0.png": "3570",
	"./icon_work_proposal_icon_1.png": "7919",
	"./icon_work_proposal_icon_10.png": "83c5",
	"./icon_work_proposal_icon_11.png": "1400",
	"./icon_work_proposal_icon_12.png": "3d5b",
	"./icon_work_proposal_icon_13.png": "9a07",
	"./icon_work_proposal_icon_15.png": "773e",
	"./icon_work_proposal_icon_2.png": "d02e",
	"./icon_work_proposal_icon_3.png": "044b",
	"./icon_work_proposal_icon_4.png": "451f",
	"./icon_work_proposal_icon_5.png": "526c",
	"./icon_work_proposal_icon_6.png": "c3e4",
	"./icon_work_proposal_icon_7.png": "86fe",
	"./icon_work_proposal_icon_8.png": "911a",
	"./icon_work_proposal_icon_9.png": "a4b4",
	"./icon_worker.png": "fa88",
	"./icon_working.png": "bb17",
	"./img/Avatar@2x.png": "9d7eb",
	"./img/AvatarSleep@2x.png": "7bfe",
	"./img/Avatar_people@2x.png": "afba",
	"./img/CascadeSelector/allSel.png": "19e2",
	"./img/CascadeSelector/allSel_1.png": "b1a1",
	"./img/CascadeSelector/close-tag.png": "f359",
	"./img/CascadeSelector/mulSel.png": "ed4f",
	"./img/CascadeSelector/mulSel_1.png": "5c05",
	"./img/CascadeSelector/noSel.png": "39ab",
	"./img/CascadeSelector/right-arrow.png": "1829",
	"./img/LOGO@2x.png": "f223",
	"./img/breath@2x.png": "658a",
	"./img/breath_alarm@2x.png": "9a98",
	"./img/breath_blue.png": "46c7",
	"./img/breath_gary.png": "51d9",
	"./img/breath_red@2x.png": "75cd",
	"./img/ceshui.png": "8cbb",
	"./img/chiyan.png": "6af2",
	"./img/dianzi.png": "006d",
	"./img/fallDown_grey@2x.png": "9788",
	"./img/fallDown_red@2x.png": "0383",
	"./img/guilv.png": "f995",
	"./img/h5_details_icon_heart_d@2x.png": "2223",
	"./img/h5_share_matching_d@2x.png": "b8b6",
	"./img/h5_share_quotes_left_d@2x.png": "6e36",
	"./img/heart@2x(1).png": "0f54",
	"./img/heart@2x.png": "3e61",
	"./img/heart_alarm@2x.png": "172f",
	"./img/heart_gary.png": "44ce",
	"./img/heart_green.png": "f493",
	"./img/heshui.png": "982f",
	"./img/iconFalldownGrey@2x.png": "20b7",
	"./img/iconLeaveBedWhite@2x.png": "bb55",
	"./img/iconLeftRight@2x.png": "4ed0",
	"./img/iconSleep@2x.png": "1fda",
	"./img/iconSleepAlarm_red@2x.png": "8d80",
	"./img/iconSleep_Red@2x.png": "157e",
	"./img/iconSleep_blue@2x.png": "f706",
	"./img/iconSleep_grey@2x.png": "f81f",
	"./img/iconSleep_white@2x.png": "126c",
	"./img/iconToilet_blackBG_large@2x.png": "e057",
	"./img/iconToilet_blue@2x.png": "5e2c",
	"./img/iconToilet_blueH@2x.png": "05b5",
	"./img/iconToilet_grey@2x.png": "3d6d",
	"./img/iconToilet_red@2x.png": "28c7",
	"./img/iconToilet_redBG@2x.png": "70bc",
	"./img/iconToilet_white@2x.png": "d9ed",
	"./img/icon_admin_nursing_person_delete_1.png": "0e00",
	"./img/icon_admin_nursing_person_edit_1.png": "3770",
	"./img/icon_falldown@2x.png": "ad2d",
	"./img/icon_unscramble_down_h@2x.png": "e455",
	"./img/icon_unscramble_up_h@2x.png": "38e4",
	"./img/image_middle_condition2_d@2x.png": "27c2",
	"./img/image_middle_condition2_d_gif_1.png": "f646",
	"./img/image_middle_condition_d@2x.png": "036c",
	"./img/image_middle_empty_check_d@2x.png": "be45",
	"./img/image_middle_empty_d@2x.png": "c0e4",
	"./img/image_middle_lose_wifi_d@2x.png": "bd0e",
	"./img/img_loginbg@2x.png": "1a45",
	"./img/juhua.png": "4b28",
	"./img/kafei.png": "71df",
	"./img/leaveBed_grey@2x.png": "3bd5",
	"./img/leaveBed_red@2x.png": "e039",
	"./img/leftFlip@2x(1).png": "f7d5",
	"./img/leftFlip@2x.png": "bc38",
	"./img/leftFlower@2x.png": "a509",
	"./img/report_details_icon_bodymove_d@2x.png": "65aa",
	"./img/report_details_icon_breathe_d@2x.png": "3c75",
	"./img/report_details_icon_frequency_d@2x.png": "793d",
	"./img/report_details_icon_heart_d@2x.png": "e1c1",
	"./img/report_icon_details_d@2x.png": "1015c",
	"./img/report_icon_good_d@2x.png": "7b25",
	"./img/report_icon_notice_Yellow.png": "0ab5",
	"./img/report_icon_notice_d@2x.png": "b93e",
	"./img/report_index_icon_bed_d@2x.png": "62aa",
	"./img/report_index_icon_clock_d@2x.png": "f0e6",
	"./img/rightFlip(1).png": "ac5d",
	"./img/rightFlip@2x.png": "7652",
	"./img/rightFlower@2x.png": "dc32",
	"./img/right_icon.png": "4a52",
	"./img/toilet_alarm@2x.png": "3cdc",
	"./img/toilet_blue@2x.png": "a884",
	"./img/toilet_dis@2x.png": "e8b6",
	"./img/toilet_occupied@2x.png": "ce2b",
	"./img/toilet_preAlarm@2x.png": "021a",
	"./img/toilet_red@2x.png": "47c2",
	"./img/tqzl.png": "504a",
	"./img/warning-circle-fill@2x.png": "562b",
	"./img/wendu.png": "1661",
	"./img/wuxiu.png": "c87a",
	"./img/yanjiu.png": "b8d9",
	"./img/yundong.png": "fd03",
	"./img/zhentou.png": "dbe1",
	"./img_logo.png": "b883",
	"./indexbanner.png": "9416",
	"./jia.png": "e5a7",
	"./login_passwrod.png": "a1f0",
	"./menu_selected.png": "898d",
	"./passwrod_biyanjing.png": "9a10",
	"./passwrod_yanjing.png": "10f0",
	"./path.png": "46c8",
	"./qlAwake.png": "f9c5",
	"./qrDaSanJiao.png": "2c30",
	"./rJt.png": "bc5c",
	"./redTriangle.png": "8563",
	"./red_cir_Sel.png": "61eb",
	"./red_cir_noSel.png": "e357",
	"./repeTopBg.png": "d088",
	"./report_bg_advice_d.png": "e117",
	"./report_detail_icon_down_h@2x.png": "708e",
	"./report_detail_icon_down_h@2x2.png": "519e",
	"./report_icon_notice_d@2x.png": "2f6d",
	"./report_pic_color_d@2x.png": "a761",
	"./report_title_advice_d3.png": "9089",
	"./report_title_advice_d@2x.png": "17d0",
	"./sjAfter.png": "4ad2",
	"./sjAfter2.png": "d631",
	"./sleepBegin.png": "5b47",
	"./sleepEnd.png": "2d8d",
	"./soIcon_down_green.png": "7d44",
	"./soIcon_down_red.png": "15f1",
	"./soIcon_up_green.png": "3b40",
	"./soIcon_up_red.png": "1abc",
	"./static/2.4.png": "7489",
	"./static/5.png": "2adc",
	"./static/api.png": "bc6e",
	"./static/apiHL.png": "0094",
	"./static/back.png": "ed13",
	"./static/back2.png": "e448",
	"./static/bed.png": "197c",
	"./static/bottom.png": "0b28",
	"./static/btn_back_ove.png": "98ef",
	"./static/btn_reset_dis.png": "b648",
	"./static/btn_reset_hover.png": "1656",
	"./static/btn_reset_nor.png": "a45e",
	"./static/c1.png": "af34",
	"./static/c2.png": "5beb",
	"./static/c3.png": "9885",
	"./static/c4.png": "bec5",
	"./static/c5.png": "4ccb",
	"./static/c6.png": "61f3",
	"./static/c7.png": "b0c2",
	"./static/c8.png": "9b35",
	"./static/c9.png": "86bc",
	"./static/calendar.png": "f07a",
	"./static/check-circle-fill.png": "6702",
	"./static/check.png": "99ec",
	"./static/close.png": "4032",
	"./static/comment1.png": "a50d",
	"./static/comment2.png": "86af",
	"./static/comment3.png": "3061",
	"./static/comment4.png": "31d5",
	"./static/component.png": "cb13",
	"./static/componentHL.png": "f290",
	"./static/continue.png": "1fb2",
	"./static/deviceType.png": "3450",
	"./static/dxychxIconWenhao.png": "22a44",
	"./static/electrify.png": "5849",
	"./static/empty.png": "ab6e",
	"./static/energy.png": "6998",
	"./static/flipLeft.png": "1156",
	"./static/flipRight.png": "4870",
	"./static/google.png": "7991",
	"./static/great.png": "92f3",
	"./static/greenTriangle.png": "e117a",
	"./static/h5_btn_forward_h.png": "c5a2",
	"./static/h5_btn_into_h.png": "0df0",
	"./static/h5_btn_record_h.png": "284d",
	"./static/h5_btn_return_white_h.png": "3315",
	"./static/h5_btn_set_h.png": "067f",
	"./static/h5_share_matching_d@2x.png": "d5ce",
	"./static/h5_share_quotes_left_d@2x.png": "bb80",
	"./static/head.png": "c9bf",
	"./static/home_bg1_d.png": "9e63",
	"./static/home_bg1_d@2x.png": "6ac3",
	"./static/home_bg2_d@2x.png": "3871",
	"./static/hxlIcon.png": "3ac15",
	"./static/hxsd_img1.png": "7b3e5",
	"./static/hxsd_img2.png": "0064",
	"./static/icon_AHI.png": "889e",
	"./static/icon_GoDown.png": "0e7f",
	"./static/icon_GoUp.png": "c3e5",
	"./static/icon_SleepLeave.png": "aec8",
	"./static/icon_SleepLeaveTime.png": "40f1",
	"./static/icon_SleepLeaveTime_36.png": "f27d",
	"./static/icon_SleepLeave_36.png": "a46a",
	"./static/icon_SleepProportion_24.png": "270c",
	"./static/icon_SleepTime.png": "27ba",
	"./static/icon_SleepTime_36.png": "8818",
	"./static/icon_SleepTurn.png": "a899",
	"./static/icon_SleepTurn_36.png": "2833",
	"./static/icon_activity.png": "09b1",
	"./static/icon_breath.png": "b19d",
	"./static/icon_breathEvent.png": "c02f",
	"./static/icon_breath_24.png": "fc90",
	"./static/icon_breath_dis.png": "9920",
	"./static/icon_check.png": "fbff",
	"./static/icon_clock.png": "4051",
	"./static/icon_dealTime.png": "2e675",
	"./static/icon_dealing.png": "8540",
	"./static/icon_deepSleep.png": "cf50",
	"./static/icon_deepSleep_dis.png": "c994",
	"./static/icon_deepSleep_nor.png": "d221",
	"./static/icon_emotion.png": "590c",
	"./static/icon_fallDown.png": "f099",
	"./static/icon_falldown2.png": "6d44",
	"./static/icon_heartRate.png": "7ac0",
	"./static/icon_heartRate_24.png": "c5d1",
	"./static/icon_heartRate_24@2x.png": "565a",
	"./static/icon_heart_dis.png": "f0af",
	"./static/icon_keep.png": "73cc",
	"./static/icon_lightSleep_dis.png": "3b94",
	"./static/icon_lightSleep_nor.png": "788e",
	"./static/icon_notice.png": "6c80",
	"./static/icon_noworking.png": "87a2",
	"./static/icon_offline.png": "9471",
	"./static/icon_onlineTime.png": "6f44",
	"./static/icon_responseTime.png": "a50a",
	"./static/icon_share.png": "06ae",
	"./static/icon_sleepBreath.png": "2e17",
	"./static/icon_sleepScore.png": "ff54",
	"./static/icon_star.png": "5050",
	"./static/icon_starB.png": "9de0",
	"./static/icon_trashCan_dis.png": "ba05",
	"./static/icon_trashCan_nor.png": "4f62",
	"./static/icon_trashCan_ove (1).png": "74a1",
	"./static/icon_trashCan_ove.png": "0ab7",
	"./static/icon_unscramble_up_h@2x.png": "7ca2",
	"./static/icon_user.png": "66b6",
	"./static/icon_wake_dis.png": "c807",
	"./static/icon_worker.png": "3f59",
	"./static/icon_working.png": "6790",
	"./static/image_middle_condition_d@2x.png": "089b",
	"./static/image_middle_empty_check_d@2x.png": "89c0",
	"./static/image_middle_empty_d@2x.png": "e9a0",
	"./static/image_middle_lose_wifi_d@2x.png": "79ac",
	"./static/img_bk.png": "e4cb",
	"./static/img_logo.png": "ae0d",
	"./static/indexbanner.png": "8369",
	"./static/left.png": "5e4a",
	"./static/light.png": "3d73",
	"./static/locationAN.png": "5e18",
	"./static/locationIOS.png": "d98c",
	"./static/login_passwrod.png": "a634",
	"./static/logo.png": "69a4",
	"./static/menu_selected.png": "6a6d",
	"./static/passwrod_biyanjing.png": "490b",
	"./static/passwrod_yanjing.png": "92df",
	"./static/path.png": "b937",
	"./static/press.png": "e52f",
	"./static/press1.png": "c454",
	"./static/qlAwake.png": "72a8",
	"./static/redTriangle.png": "e3f1",
	"./static/reportHead.png": "1141",
	"./static/report_detail_icon_down_h@2x.png": "d942",
	"./static/report_details_icon_bed_d@2x.png": "6526",
	"./static/report_details_icon_clock_d@2x.png": "9167",
	"./static/report_icon_details_d@2x.png": "50c1",
	"./static/report_image_advice_d@2x.png": "face",
	"./static/report_index_icon_bed_d@2x.png": "6793",
	"./static/right.png": "7066",
	"./static/scan.png": "768e",
	"./static/setting.png": "3377",
	"./static/share.png": "76f9",
	"./static/sharelogo.png": "956f",
	"./static/sleepBegin.png": "ceba",
	"./static/sleepEnd.png": "df4a",
	"./static/switch.png": "5503",
	"./static/tdxqIcon.png": "2e3f",
	"./static/template.png": "3d26",
	"./static/templateHL.png": "bff1",
	"./static/top.png": "d0f2",
	"./static/unbound.png": "7511",
	"./static/uni.png": "55c0",
	"./static/user_name.png": "eecb",
	"./static/video/report_detail_icon_down_h@2x.png": "0e82",
	"./static/warning-circle-fill.png": "51c1",
	"./static/wifi.png": "f2f5",
	"./static/wifi2.png": "b4b4",
	"./static/xlIcon.png": "c7b5",
	"./szhxNo.png": "e046",
	"./szhxNo1.png": "a1bb",
	"./szhxNo2.png": "5603",
	"./szhxNo3_1.png": "ac5c",
	"./szhxNo3_2.png": "285c",
	"./szhxNo3_3.png": "123f",
	"./szhx_hx.png": "c562",
	"./szhx_titIcon1.png": "f3e8",
	"./szhx_titIcon2.png": "fb40",
	"./szhx_titIcon3.png": "8e7f",
	"./szhx_titIcon4.png": "421e",
	"./szhx_titIcon5.png": "223e",
	"./szhx_titIcon6.png": "d671",
	"./tableIcon.png": "0ba4",
	"./tableIcon1.png": "5126",
	"./tableIcon2.png": "ac04",
	"./tan_bjSingle1.png": "d6c2",
	"./tan_bjSingle2.png": "e5d2",
	"./tan_bjSingle3.png": "361e",
	"./tan_bjSingle4.png": "4e02",
	"./tan_bjSingle5.png": "4c15",
	"./tempInfoIcon.png": "5b75",
	"./user_name.png": "d24f",
	"./warning-circle-fill.png": "e43f",
	"./wenhaoIcon.png": "8747"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";